import { BaseModel } from "../Generics/BaseModel"
import { PersonEntity } from "../Person/PersonEntity"
import { ECourierVehicleType } from "../../Enum/ECourierVehicleType"
import { ECourierStatusType } from "../../Enum/ECourierStatusType"
import { DeliveryEntity } from "../DeliveryEntity/DeliveryEntity"

export class CourierEntity extends BaseModel {
  id: string

  personEntityId: number

  personEntity: PersonEntity

  vehicleType: ECourierVehicleType

  status: ECourierStatusType

  isShared: boolean

  lastLatitude?: number

  lastLongitude?: number

  lastSeenDatetime?: Date

  deliveries: DeliveryEntity[]

  constructor(data: Partial<CourierEntity> = {}) {
    super()

    this.id = data.id ?? ""

    this.personEntityId = data.personEntityId ?? -1

    this.personEntity = new PersonEntity(data.personEntity)

    this.vehicleType = data.vehicleType ?? ECourierVehicleType.MotorCycle

    this.status = data.status ?? ECourierStatusType.Offline

    this.isShared = data.isShared ?? false

    this.lastLatitude = data.lastLatitude

    this.lastLongitude = data.lastLongitude

    this.lastSeenDatetime = data.lastSeenDatetime ? new Date(data.lastSeenDatetime) : undefined

    this.deliveries = (data.deliveries ?? []).map((e) => new DeliveryEntity(e))
  }
}
